export default __webpack_public_path__ + "static/media/screen3.3a9b404a.svg";